"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDevLogger = exports.devLog = exports.resolveReturnable = exports.logPerformance = exports.logPerformanceLog = exports.logPerformanceEnd = exports.logPerformanceBegin = exports.debugLogType = exports.debugLog = exports.setupDatabaseWatchDebugMode = void 0;
const lodash_1 = require("lodash");
const performanceLoggingEnabled = process.env.PERFORMANCE_LOGGING_ENABLED || false;
const devLoggingEnabled = (_a = process.env.DEV_LOGGING_ENABLED) !== null && _a !== void 0 ? _a : process.env.NODE_ENV === 'development';
// #region Debug Logging
let debugMode = 0;
const setupDatabaseWatchDebugMode = (dbInstance) => {
    dbInstance
        .raw(`SELECT value FROM static.settings WHERE name = 'debug_mode'`)
        .then((data) => {
        var _a;
        const debugSetting = (_a = data.rows[0]) === null || _a === void 0 ? void 0 : _a.value;
        debugMode = Number(debugSetting) || 0;
        dbInstance.client.acquireConnection().then((client) => {
            client.query('LISTEN debug_mode');
            client.on('notification', (msg) => {
                debugMode = Number(msg.payload) || 0;
                console.log('debug_mode', debugMode);
            });
            client.on('error', (e) => {
                console.log('Debug Mode Setting Listener', e.message);
                dbInstance.client.releaseConnection(client);
            });
            client.on('end', () => {
                dbInstance.client.releaseConnection(client);
            });
        });
    })
        .catch((e) => {
        console.log('error setting up watch db, will try again in one minute', e);
        setTimeout(() => (0, exports.setupDatabaseWatchDebugMode)(dbInstance), 1000 * 60);
    });
};
exports.setupDatabaseWatchDebugMode = setupDatabaseWatchDebugMode;
/**
 * Logs out debug log if debug mode is on
 * @param message Message to log
 * @param type Bitwise {@link debugLogType}
 * @param ...args Optional params to pass to {@link console.log}
 */
const debugLog = (message, type, ...args) => {
    if (debugMode & type) {
        console.log(`DEBUG_LOG: ${typeof message === 'string' ? message : message()}`, ...args);
    }
};
exports.debugLog = debugLog;
//Debug logging is determined by a bitwise check - any new log type should have a value of double the previous
exports.debugLogType = {
    incomingEventPipeline: 1,
    recordProjection: 2,
    recordPersistence: 4,
    commandProcessing: 8,
    queueManagement: 16,
    serviceMonitoring: 32,
    aggregateManagement: 64,
    cacheProcessing: 128,
};
// #endregion
// #region Performance Logging
const performanceStart = {};
const logPerformanceBegin = (performanceLogEntry) => {
    switch (performanceLogEntry.method) {
        case 'performance':
            const start = performanceStart[performanceLogEntry.name];
            if (start) {
                console.warn(`Timer '${performanceLogEntry.name}' already exists.`);
            }
            else {
                performanceStart[performanceLogEntry.name] = performance.now();
            }
            break;
        default:
            console.time(performanceLogEntry.name);
            break;
    }
    console.info(`${performanceLogEntry.name} - timer started`);
};
exports.logPerformanceBegin = logPerformanceBegin;
const logPerformanceEnd = (performanceLogEntry) => {
    switch (performanceLogEntry.method) {
        case 'performance':
            const start = performanceStart[performanceLogEntry.name];
            if (!start) {
                console.warn(`Timer '${performanceLogEntry.name}' does not exist`);
            }
            else {
                console.log(`${performanceLogEntry.name}: ${performance.now() - start}ms - timer ended`);
                performanceStart[performanceLogEntry.name] = null;
            }
            break;
        default:
            console.timeEnd(performanceLogEntry.name);
            break;
    }
};
exports.logPerformanceEnd = logPerformanceEnd;
const logPerformanceLog = (performanceLogEntry) => {
    switch (performanceLogEntry.method) {
        case 'performance':
            const start = performanceStart[performanceLogEntry.name];
            if (!start) {
                console.warn(`Timer '${performanceLogEntry.name}' does not exist`);
            }
            else {
                console.log(`${performanceLogEntry.name}: ${performance.now() - start}ms${' - ' + performanceLogEntry.data}`);
            }
            break;
        default:
            console.timeLog(performanceLogEntry.name, performanceLogEntry.data);
            break;
    }
};
exports.logPerformanceLog = logPerformanceLog;
const logPerformance = (performanceLogEntry) => {
    if (!performanceLoggingEnabled) {
        return;
    }
    if (performanceLogEntry.begin) {
        (0, exports.logPerformanceBegin)(performanceLogEntry);
        return;
    }
    if (performanceLogEntry.end) {
        (0, exports.logPerformanceEnd)(performanceLogEntry);
        return;
    }
    (0, exports.logPerformanceLog)(performanceLogEntry);
};
exports.logPerformance = logPerformance;
// #endregion
// #region Dev Logging
// TODO: Upgrade `eslint` to support inline tuple types (i.e. `[]`, `[...TParentMessageArgs, ...any[]]`).
const emptyArray = [];
const resolveReturnable = (returnable, ...args) => returnable instanceof Function ? returnable(...args) : returnable;
exports.resolveReturnable = resolveReturnable;
exports.devLog = !devLoggingEnabled
    ? lodash_1.noop
    : (messageFn, ...args) => !!devLoggingEnabled && console.log(`${(0, exports.resolveReturnable)(messageFn)}${args.length ? ':' : ''}`, ...args);
const createDevLogger = (parentMessageFn, ...parentArgs // TODO: Simplify `args` and standard interpretations with `options` param.
) => !devLoggingEnabled
    ? lodash_1.noop
    : (messageFn, ...args) => {
        const parentMessage = (0, exports.resolveReturnable)(parentMessageFn, ...args);
        const message = (0, exports.resolveReturnable)(messageFn); // TODO: If function, include `parentMessage` as parameter, as alternative to `.join`?
        return (0, exports.devLog)(() => [parentMessage, message].filter(m => !(0, lodash_1.isEmpty)(m)).join(''), ...(0, lodash_1.concat)(parentArgs, typeof parentMessageFn === 'function' ? args.slice(parentMessageFn.length) : args));
    };
exports.createDevLogger = createDevLogger;
// #endregion
